import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getSpecimens (params, loggedIn) {
  apiConsolelog('api: getSpecimens(): loggedIn = %s, params = %s', loggedIn, JSON.stringify(params))

  const url = loggedIn ? '/auth/specimen' : '/specimen'

  return request({
    url: url,
    method: 'get',
    params
  })
}

export function getSpecimenPositions (params, loggedIn) {
  apiConsolelog('api: getSpecimenPositions(): loggedIn = %s, params = %s', loggedIn, JSON.stringify(params))

  const url = loggedIn ? '/auth/specimen-position' : '/specimen-position'

  return request({
    url: url,
    method: 'get',
    params
  })
}

export function getSpecimenById (id, loggedIn) {
  apiConsolelog('api: getSpecimenById(): loggedIn = %s, id = %s', loggedIn, id)

  const url = loggedIn ? '/auth/specimen/' + id : '/specimen/' + id

  return request({
    url: url,
    method: 'get'
  })
}

export function getSpecimenByCatalogNumber (catalogNumber, loggedIn) {
  apiConsolelog('api: getSpecimenById(): loggedIn = %s, catalogNumber = %s', loggedIn, catalogNumber)

  const url = loggedIn ? '/auth/specimen/catalog/' + catalogNumber : '/specimen/catalog/' + catalogNumber

  return request({
    url: url,
    method: 'get'
  })
}

export function postFeedback (id, data) {
  apiConsolelog('api: postFeedback(): id = %s, data = %s', id, JSON.stringify(data))

  return request({
    url: '/specimen/' + id + '/feedback',
    method: 'post',
    data
  })
}

export function getSpecimenNumberPrefix () {
  apiConsolelog('api: getSpecimenNumberPrefix()')

  return request({
    url: '/get-specimen-number-prefix',
    method: 'get'
  })
}

export function downloadSpecimenImage (id) {
  apiConsolelog('api: downloadSpecimenImage(): id = %d', id)

  return request({
    url: '/specimen/' + id + '/download/pic_raw',
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadAndEmailSpecimenSearchResults (params, loggedIn) {
  apiConsolelog('api: downloadAndEmailSpecimenSearchResults(): loggedIn = %s, params = %s', loggedIn, JSON.stringify(params))

  const url = loggedIn ? '/auth/excel-requests' : '/excel-requests'

  return request({
    url: url,
    method: 'post',
    params
  })
}
